<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import { useAuthStore } from '../../../../stores/auth'
import { useTenantsStore } from '../../../../stores/tenants'

type Option = {
  text: string
  value: string
}

const authStore = useAuthStore()
const tenantsStore = useTenantsStore()

const selected = ref(authStore.getTenantCode() || '')

const isSuperAdmin = computed(() => authStore.user?.role === 'SUPER_ADMIN')

const options = computed<Option[]>(() => {
  const list = tenantsStore.items.map((tenant) => ({
    text: `${tenant.name} (${tenant.code})`,
    value: tenant.code,
  }))
  return [{ text: 'All tenants', value: 'all' }, ...list]
})

const loadTenants = async () => {
  if (!isSuperAdmin.value) return
  if (tenantsStore.items.length > 0) return
  await tenantsStore.list({ page: 1, pageSize: 100 })
}

onMounted(loadTenants)

watch(
  () => authStore.tenantCode,
  (value) => {
    selected.value = value ?? ''
  },
)

watch(selected, (value) => {
  if (!isSuperAdmin.value) return
  authStore.setTenantCode(value || null)
})
</script>

<template>
  <div v-if="isSuperAdmin" class="tenant-dropdown">
    <VaSelect
      v-model="selected"
      :options="options"
      text-by="text"
      value-by="value"
      placeholder="Tenant"
      size="small"
      class="tenant-dropdown__select"
    />
  </div>
</template>

<style scoped lang="scss">
.tenant-dropdown {
  display: flex;
  align-items: center;
}

.tenant-dropdown__select {
  min-width: 200px;
}

@media screen and (max-width: 640px) {
  .tenant-dropdown__select {
    min-width: 140px;
  }
}
</style>
